import React, { Component } from 'react';
import styled from 'styled-components';

import {
  PageBaseLayout,
  PageDescription,
  ProgramLogosSection,
  Heading2,
  Heading3,
  ImagePluTextBox,
  Button,
  LinkHandle,
} from '../..';
import { getData, BreadTreeElement } from '../../../utils/PageApi';
import ImmigrationStepsSection from './ImmigrationStepsSection';
import COSImmigrationLogoJp from '../../../assets/logo/COSImmigrationConsultingJp.svg';
import { buttonText } from '../../../constants/buttonText';
import { BottomSectionText } from '../../../constants/BottomSectionText';
import colors from '../../colors';

const PriceDiv = styled.div`
  margin-top: 80px;
  margin-bottom: 80px;
`;
const FlexDiv = styled.div`
  display: flex;
  & .buttonL,
  .buttonR {
    width: 50%;
  }
  & .buttonL {
    margin-right: 0.8rem;
  }
  & .buttonR {
    margin-left: 0.8rem;
  }
`;

type PageDataType = {
  title: { rendered: string };
  link: string;
  featured_media: number;
  acf: {
    metaDescription: string;
    heroImg: string;
    subtitle: string;
    pageDescription: string;
    ButtonText1: string;
    ButtonUrl1: string;
    ButtonText2: string;
    ButtonUrl2: string;
    programTitle: string;
    programText: string;
    programFeatureTitle1: string;
    programFeatureTitle2: string;
    programFeatureTitle3: string;
    programFeatureText1: string;
    programFeatureText2: string;
    programFeatureText3: string;
    programFeatureImg1: string;
    programFeatureImg2: string;
    programFeatureImg3: string;
    stepTitle: string;
    step1Title: string;
    step1Img: string;
    step2Title: string;
    step2Img: string;
    step3Title: string;
    step3Img: string;
    step4Title: string;
    step4Img: string;
    priceTitle: string;
    priceTable: string;
  };
  slug: string;
  parent: number;
};

interface OwnProps {}
interface OwnState {
  data: PageDataType;
  breadTreeElements: BreadTreeElement[];
}

class Immigration extends Component<OwnProps, OwnState> {
  constructor(ownProps: any, ownState: any) {
    super(ownProps, ownState);
    this.state = {
      data: {
        title: { rendered: '' },
        link: '',
        featured_media: 0,
        acf: {
          metaDescription: '',
          heroImg: '',
          subtitle: '',
          pageDescription: '',
          ButtonText1: '',
          ButtonUrl1: '',
          ButtonText2: '',
          ButtonUrl2: '',
          programTitle: '',
          programText: '',
          programFeatureTitle1: '',
          programFeatureTitle2: '',
          programFeatureTitle3: '',
          programFeatureText1: '',
          programFeatureText2: '',
          programFeatureText3: '',
          programFeatureImg1: '',
          programFeatureImg2: '',
          programFeatureImg3: '',
          stepTitle: '',
          step1Title: '',
          step1Img: '',
          step2Title: '',
          step2Img: '',
          step3Title: '',
          step3Img: '',
          step4Title: '',
          step4Img: '',
          priceTitle: '',
          priceTable: '',
        },
        slug: '',
        parent: 0,
      },
      breadTreeElements: [],
    };
  }

  async createData() {
    let pageId = 462;
    const state = await getData<PageDataType>(pageId);
    this.setState(state);
  }
  componentDidMount() {
    this.createData();
  }

  render() {
    let data = this.state.data;
    let dataAcf = data.acf;
    let title = data.title.rendered;

    return (
      <PageBaseLayout
        metaDescription={dataAcf.metaDescription}
        BreadTreeElements={this.state.breadTreeElements}
        heroImgURL={dataAcf.heroImg}
        title={title}
        subTitle={dataAcf.subtitle}
        eyeCatchId={data.featured_media}
        ogLink={data.link}
        bottomSectionText={BottomSectionText.pattern1}
        bottomSectionColor={colors.lightGray}
        bottomButtonText={buttonText.freeConsulting}
        bottomButtonSize={'23.7rem'}
      >
        <PageDescription>
          <div
            dangerouslySetInnerHTML={{
              __html: dataAcf.pageDescription,
            }}
          />
          <FlexDiv>
            <Button theme={{ main: '100%' }} className="buttonL">
              <LinkHandle to={dataAcf.ButtonUrl1}>
                {dataAcf.ButtonText1}
              </LinkHandle>
            </Button>
            <Button theme={{ main: '100%' }} className="buttonR">
              <LinkHandle to={dataAcf.ButtonUrl2}>
                {dataAcf.ButtonText2}
              </LinkHandle>
            </Button>
          </FlexDiv>
        </PageDescription>
        <ProgramLogosSection logo1={COSImmigrationLogoJp} logo2={''} />
        <Heading2>{dataAcf.programTitle}</Heading2>
        <div dangerouslySetInnerHTML={{ __html: dataAcf.programText }} />

        <ImagePluTextBox
          imgURL={dataAcf.programFeatureImg1}
          alt={dataAcf.programFeatureTitle1}
          isImgRightSide={true}
          classname={null}
        >
          <Heading3>{dataAcf.programFeatureTitle1}</Heading3>
          <div
            dangerouslySetInnerHTML={{ __html: dataAcf.programFeatureText1 }}
          />
        </ImagePluTextBox>
        <ImagePluTextBox
          imgURL={dataAcf.programFeatureImg2}
          alt={dataAcf.programFeatureTitle2}
          isImgRightSide={false}
          classname={null}
        >
          <Heading3>{dataAcf.programFeatureTitle2}</Heading3>
          <div
            dangerouslySetInnerHTML={{ __html: dataAcf.programFeatureText2 }}
          />
        </ImagePluTextBox>
        <ImagePluTextBox
          imgURL={dataAcf.programFeatureImg3}
          alt={dataAcf.programFeatureTitle3}
          isImgRightSide={true}
          classname={null}
        >
          <Heading3>{dataAcf.programFeatureTitle3}</Heading3>
          <div
            dangerouslySetInnerHTML={{ __html: dataAcf.programFeatureText3 }}
          />
        </ImagePluTextBox>
        <ImmigrationStepsSection
          title={dataAcf.stepTitle}
          step1Title={dataAcf.step1Title}
          step1Img={dataAcf.step1Img}
          step2Title={dataAcf.step2Title}
          step2Img={dataAcf.step2Img}
          step3Title={dataAcf.step3Title}
          step3Img={dataAcf.step3Img}
          step4Title={dataAcf.step4Title}
          step4Img={dataAcf.step4Img}
        />
        <PriceDiv>
          <Heading2>{dataAcf.priceTitle}</Heading2>
          <div dangerouslySetInnerHTML={{ __html: dataAcf.priceTable }} />
        </PriceDiv>
      </PageBaseLayout>
    );
  }
}
export default Immigration;
